// @ vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const WizardError = require('components/commons/wizardError/wizardError');

// @utilities
const { PROC_OPEN_YOUNG_FISCAL_DATA } = require('utilities/tagging');

class OpenYoungFiscalDataError extends React.Component {
    render() {
        const goBackButton = {
            label: (
                <FormattedText
                    value="openYoungFiscalData-openYoungFiscalData_errorBackButtonText"
                />
            ),
            url: `/myprofile/edit`
        };
        return (
            <WizardError
                errorMessage={formatText('openYoungFiscalData-openYoungFiscalData_errorTitle')}
                mainButton={goBackButton}
                processType={PROC_OPEN_YOUNG_FISCAL_DATA}
            >
                <FormattedText
                    value="openYoungFiscalData-openYoungFiscalData_errorText"
                />
            </WizardError>
        );
    }
}

module.exports = OpenYoungFiscalDataError;
